import UiForm from "./UiForm";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import UiGroup from "./UiGroup";

/**
 * 港口表单
 * @description 自动生成的代码,请勿修改
 */
export default class DtoFormParamPort extends UiForm<string> {
    constructor() {
        //无参构造函数
        super()
        this.UiGroups = [];
    }

    [proName: string]: any;
    /**
     * 国家
     */
    ParamCountryId?: string;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 全名
     */
    FullName?: string;
    /**
     * 港口代码
     */
    Code?: string;
    /**
     * 中国海关港口代码
     */
    ChinaCustomsCode?: string;
    /**
     * 鸭嘴兽代码
     */
    YaZuiShouCode?: string;
    /**
     * 飞鸵Id
     */
    FreighTowerPortId?: string;
}

/**
 * 港口表单-表单校验
 */
export const DtoFormParamPortRules = {
    ParamCountryId: [
        {
            required: true,
            message: "信息不能为空",
            trigger: "change",
        },
    ],
    NameZh: [
        {
            max: 256,
            message: "文本长度不能超过 256 个字符",
            trigger: "blur",
        },
    ],
    NameEn: [
        {
            max: 256,
            message: "文本长度不能超过 256 个字符",
            trigger: "blur",
        },
    ],
    FullName: [
        {
            max: 10240,
            message: "文本长度不能超过 10240 个字符",
            trigger: "blur",
        },
    ],
    Code: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    ChinaCustomsCode: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
    YaZuiShouCode: [
        {
            max: 128,
            message: "文本长度不能超过 128 个字符",
            trigger: "blur",
        },
    ],
}

/**
 * 港口表单-设置项
 */
export const DtoFormParamPortMiezzFormItems: MiezzFormItem[] = [
  {
    Prop: "ParamCountryId",
    Label: "国家",
    Customize: true,
  },
  {
    Prop: "NameZh",
    Label: "中文名称",
    Customize: true,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Customize: true,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Customize: true,
  },
  {
    Prop: "Code",
    Label: "港口代码",
    Customize: true,
  },
  {
    Prop: "ChinaCustomsCode",
    Label: "中国海关港口代码",
    Customize: true,
  },
  {
    Prop: "YaZuiShouCode",
    Label: "鸭嘴兽代码",
    Type: EnumMiezzFormItemType.InputText,
  },
  {
    Prop: "FreighTowerPortId",
    Label: "飞鸵Id",
    Customize: true,
  },
]
